export const CUSTOM_BUTTON_VARIANT = {
  contained: 'contained',
  outlined: 'outlined',
  text: 'text',
};

export const CUSTOM_BUTTON_COLOR = {
  primary: 'primary',
  silver: 'silver',
  upsell: 'upsell',
  danger: 'danger',
  gray: 'gray',
  default: 'default',
};

export const CUSTOM_BUTTON_SIZE = {
  large: 'large',
  medium: 'medium',
  small: 'small',
  smaller: 'smaller',
};
